import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AsyncRightPanel } from '@atlassian/jira-home-right-side-panel/src/async.tsx';
import { RIGHT_PANEL_WIDTH } from '@atlassian/jira-home-right-side-panel/src/constants.tsx';

type RightPanelLayoutProps = {
	children: ReactNode;
};

export const RightPanelLayout = ({ children }: RightPanelLayoutProps): React.JSX.Element => (
	<FlexLayoutWrapper>
		<LayoutLeft rightPanelWidth={RIGHT_PANEL_WIDTH}>{children}</LayoutLeft>
		<AsyncRightPanel />
	</FlexLayoutWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlexLayoutWrapper = styled.div({
	display: 'flex',
	height: '100%',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LayoutLeft = styled.div<{ rightPanelWidth: number }>({
	height: '100%',
	display: 'block',
	paddingTop: 0,
	paddingRight: token('space.500'),
	paddingBottom: 0,
	paddingLeft: token('space.500'),
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ rightPanelWidth }) => `calc(100% - ${rightPanelWidth}px)`,
	flexGrow: 1,
	minWidth: '640px',
	overflowY: 'scroll',
});
